var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageNotFound"},[_c('h1',[_vm._v("404 Página não encontrada!")]),_c('p',[_vm._v("Voltando para a página inicial em "+_vm._s(_vm.counter)+"s")])])}
var staticRenderFns = []

export { render, staticRenderFns }